<template>
  <div></div>
</template>

<script>
  export default {
    name: 'DocTitle',
    props: {
      text: String,
      canonical: {
        type: String,
        default: null
      }
    },
    created () {
      this.set();
      this.setCanonical();
    },
    watch: {
      text () {
        this.set();
      }
    },
    methods: {
      set () {
        if (!this.text) {
          document.title = 'Jagdnews';
        } else {
          document.title = this.text + ' - Jagdnews';
        }
      },

      setCanonical () {
        let path = this.canonical;

        if (!this.canonical) {
          path = this.$route.path;
        }

        document.querySelector('link[rel="canonical"]').setAttribute('href', 'https://www.gunfinder.de' + path);
      }
    }
  };
</script>
